import React from 'react';
import PropTypes from 'prop-types';
import signalR from '../../../general/js/signalr';
import NotificationItem from './NotificationItem';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class NotificationsList extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            allNotifications: [],
            notifications: []
        };

        this.unsubscribe = null;
        this.onNotificationsUpdate = this.onNotificationsUpdate.bind(this);
        this.onNotificationClose = this.onNotificationClose.bind(this);
    }

    componentDidMount() {
        this.hub = signalR.getHub(this.props.hubName);
        this.unsubscribe = this.hub.subscribe('notify', this.onNotificationsUpdate);
        signalR.connect().then(() => {
            this.hub.invoke('getAllNotifications').then(this.onNotificationsUpdate);
        });
    }

    onNotificationsUpdate(items) {
        this.updateNotifications(items);
    }

    onNotificationClose(closedItem) {
        this.hub.invoke('closeNotification', closedItem.id).then(() => {
            let newNotifications = this.state.allNotifications.filter(item => item !== closedItem);
            this.updateNotifications(newNotifications);
        });
    }

    updateNotifications(items) {
        let length = items.length;
        let start = Math.max(length - this.props.maxCount, 0);
        let notifications = items.slice(start, length);

        this.setState({
            allNotifications: items,
            notifications: notifications
        });
    }

    componentWillUnmount() {
        if (!this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        let items = this.state.notifications;

        return (
            <ReactCSSTransitionGroup
                component="div"
                className="toast-bottom-right toast-container notifications-list"
                transitionName="notification"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}>
                {items.map(item => <NotificationItem onClose={this.onNotificationClose} key={item.id} item={item}/>)}
            </ReactCSSTransitionGroup>
        );
    }
}

NotificationsList.propTypes = {
    maxCount: PropTypes.number.isRequired,
    hubName: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/notifications/js/NotificationsList.js